<app-dropdown [triggerLabel]="selectedOrgName()">
  <dev-org-selector *appDropdownContent (orgSelected)="onOrgSelected($event)" />
</app-dropdown>
